var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "Rma" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [_c("section")]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("get.RMA.General"), active: "" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerId",
                            error: _vm.$v.form.CustomerId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextCustomer/api/Customer/AutoCompleteSearch",
                              searchable: true,
                              "custom-option": true,
                              disabled: _vm.insertReadonly.CustomerId,
                              label: "Description1",
                              "or-condition-fields":
                                "Code,Description1,CommercialTitle",
                              "is-customer": true
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "CustomerId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.customer,
                              callback: function($$v) {
                                _vm.customer = $$v
                              },
                              expression: "customer"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "WarehouseId",
                            error: _vm.$v.form.WarehouseId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextWarehouse/api/Warehouse/AutoCompleteSearch",
                              "dynamic-and-condition": {
                                StatusIds: [1],
                                IsVehicle: 0
                              },
                              label: "Description1",
                              disabled: _vm.insertReadonly.WarehouseId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "WarehouseId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.warehouse,
                              callback: function($$v) {
                                _vm.warehouse = $$v
                              },
                              expression: "warehouse"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RepresentativeId",
                            error: _vm.$v.form.RepresentativeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.RepresentativeId,
                              url:
                                "VisionNextEmployee/api/Employee/AutoCompleteSearch",
                              searchable: "",
                              "or-condition-fields":
                                "Code,Description1,Name,Surname",
                              "dynamic-and-condition": { StatusIds: [1] },
                              label: "Description1"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "RepresentativeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.representative,
                              callback: function($$v) {
                                _vm.representative = $$v
                              },
                              expression: "representative"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RmaStatusId",
                            error: _vm.$v.form.RmaStatusId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.RmaStatusId,
                              "lookup-key": "RMA_STATUS"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("RmaStatusId", $event)
                              }
                            },
                            model: {
                              value: _vm.rmaStatus,
                              callback: function($$v) {
                                _vm.rmaStatus = $$v
                              },
                              expression: "rmaStatus"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ApproveEmployeeId",
                            error: _vm.$v.form.ApproveEmployeeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.ApproveEmployeeId,
                              url:
                                "VisionNextEmployee/api/Employee/AutoCompleteSearch",
                              orConditionFields:
                                "Code,Description1,Name,Surname",
                              label: "Description1"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "ApproveEmployeeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.approveEmloyee,
                              callback: function($$v) {
                                _vm.approveEmloyee = $$v
                              },
                              expression: "approveEmloyee"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ApproveNumber",
                            error: _vm.$v.form.ApproveNumber
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.ApproveNumber
                            },
                            model: {
                              value: _vm.form.ApproveNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ApproveNumber", $$v)
                              },
                              expression: "form.ApproveNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RmaTypeId",
                            error: _vm.$v.form.RmaTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.RmaTypeId,
                              "lookup-key": "RETURN_TYPE",
                              "get-lookup": ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("RmaTypeId", $event)
                              }
                            },
                            model: {
                              value: _vm.rmaType,
                              callback: function($$v) {
                                _vm.rmaType = $$v
                              },
                              expression: "rmaType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ApproveDate",
                            error: _vm.$v.form.ApproveDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: { disabled: _vm.insertReadonly.ApproveDate },
                            model: {
                              value: _vm.form.ApproveDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ApproveDate", $$v)
                              },
                              expression: "form.ApproveDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "PriceDate",
                            error: _vm.$v.form.PriceDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: { disabled: _vm.insertReadonly.PriceDate },
                            model: {
                              value: _vm.form.PriceDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "PriceDate", $$v)
                              },
                              expression: "form.PriceDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Genexp1",
                            error: _vm.$v.form.Genexp1
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Genexp1
                            },
                            model: {
                              value: _vm.form.Genexp1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Genexp1", $$v)
                              },
                              expression: "form.Genexp1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RmaDate",
                            error: _vm.$v.form.RmaDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: { disabled: _vm.insertReadonly.RmaDate },
                            model: {
                              value: _vm.form.RmaDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "RmaDate", $$v)
                              },
                              expression: "form.RmaDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "GrvNumber",
                            error: _vm.$v.form.GrvNumber
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.GrvNumber
                            },
                            model: {
                              value: _vm.form.GrvNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "GrvNumber", $$v)
                              },
                              expression: "form.GrvNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RouteId",
                            error: _vm.$v.form.RouteId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.RouteId,
                              url:
                                "VisionNextRoute/api/Route/AutoCompleteSearch",
                              "order-by-columns": [
                                { Column: "Description1", OrderByType: 0 }
                              ],
                              "dynamic-and-condition": { StatusIds: [1] },
                              "page-count": 500
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType("RouteId", $event)
                              }
                            },
                            model: {
                              value: _vm.route,
                              callback: function($$v) {
                                _vm.route = $$v
                              },
                              expression: "route"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RmaReasonId",
                            error: _vm.$v.form.RmaReasonId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.RmaReasonId,
                              url: "VisionNextRma/api/RmaReason/Search",
                              label: "Description1"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "RmaReasonId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.rmaReason,
                              callback: function($$v) {
                                _vm.rmaReason = $$v
                              },
                              expression: "rmaReason"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("get.RMA.Items") } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.RMA.Item"),
                            required: true,
                            error: _vm.$v.rmaLine.Item.ItemId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              search: _vm.searchItem,
                              label: "Code",
                              searchable: "",
                              "custom-option": true
                            },
                            model: {
                              value: _vm.rmaLine.Item,
                              callback: function($$v) {
                                _vm.$set(_vm.rmaLine, "Item", $$v)
                              },
                              expression: "rmaLine.Item"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.RMA.ItemName"),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.rmaLine.Item.Description1,
                              callback: function($$v) {
                                _vm.$set(_vm.rmaLine.Item, "Description1", $$v)
                              },
                              expression: "rmaLine.Item.Description1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.RMA.lastSalesQuantity"),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.rmaLine.Item.LastSalesQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.rmaLine.Item,
                                  "LastSalesQuantity",
                                  $$v
                                )
                              },
                              expression: "rmaLine.Item.LastSalesQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.RMA.lastSalesPrice"),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.rmaLine.Item.LastPrice,
                              callback: function($$v) {
                                _vm.$set(_vm.rmaLine.Item, "LastPrice", $$v)
                              },
                              expression: "rmaLine.Item.LastPrice"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.RMA.Cardboard"),
                            required: true,
                            error: _vm.$v.rmaLine.Quantity,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text" },
                            on: {
                              keypress: function($event) {
                                _vm.onlyForCurrencyDotOrComma($event)
                                _vm.keypress($event)
                              }
                            },
                            model: {
                              value: _vm.rmaLine.Quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.rmaLine, "Quantity", $$v)
                              },
                              expression: "rmaLine.Quantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.RMA.meanPrice"),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.rmaLine.Item.MeanPrice,
                              callback: function($$v) {
                                _vm.$set(_vm.rmaLine.Item, "MeanPrice", $$v)
                              },
                              expression: "rmaLine.Item.MeanPrice"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.RMA.listPrice"),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.rmaLine.Item.ListPrice,
                              callback: function($$v) {
                                _vm.$set(_vm.rmaLine.Item, "ListPrice", $$v)
                              },
                              expression: "rmaLine.Item.ListPrice"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.RMA.usedPrice"),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.rmaLine.Item.UsedPrice,
                              callback: function($$v) {
                                _vm.$set(_vm.rmaLine.Item, "UsedPrice", $$v)
                              },
                              expression: "rmaLine.Item.UsedPrice"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "6", lg: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "mt-4",
                                          attrs: {
                                            variant: "success",
                                            size: "sm"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.addItems()
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-plus"
                                          }),
                                          _vm._v(_vm._s(_vm.$t("insert.add")))
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("NextMultipleSelection", {
                                    attrs: {
                                      name: "RmaMultipleItem",
                                      "disabled-button": !_vm.form.CustomerId,
                                      "dynamic-and-condition": {
                                        CustomerIds: [_vm.form.CustomerId],
                                        PriceDate: _vm.form.PriceDate
                                      },
                                      "initial-values-func": _vm.initialValues,
                                      "filter-func": function(row) {
                                        return row.Quantity > 0
                                      }
                                    },
                                    model: {
                                      value: _vm.rmaLines,
                                      callback: function($$v) {
                                        _vm.rmaLines = $$v
                                      },
                                      expression: "rmaLines"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("NextExportDetail", {
                            attrs: {
                              url: "VisionNextRma/api/Rma/ExcelExportItems",
                              "record-id": _vm.form.RecordId,
                              "record-key": "rmaId",
                              "file-name": _vm.$t("get.RMA.Items")
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-table-simple",
                            {
                              attrs: { responsive: "", bordered: "", small: "" }
                            },
                            [
                              _c(
                                "b-thead",
                                [
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("insert.RMA.Item")))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("insert.RMA.ItemName"))
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("insert.RMA.Quantity"))
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("insert.RMA.UsedQuantity")
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("insert.RMA.lastSalesQuantity")
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("insert.RMA.usedPrice"))
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("list.operations")))
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tbody",
                                _vm._l(
                                  _vm.rmaLines
                                    ? _vm.rmaLines.filter(function(r) {
                                        return r.RecordState !== 4
                                      })
                                    : [],
                                  function(w, i) {
                                    return _c(
                                      "b-tr",
                                      { key: i },
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              w.Item ? w.Item.Code : w.Code
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              w.Item
                                                ? w.Item.Description1
                                                : w.Description1
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(_vm.formatValue(w.Quantity))
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(_vm.getReturnQuantity(w))
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              w.Item && w.Item.LastSalesQuantity
                                                ? w.Item.LastSalesQuantity
                                                : w.LastSalesQuantity
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(_vm.getPrice(w)))
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "b-td",
                                          { staticClass: "text-center" },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "btn mr-2 btn-danger btn-sm",
                                                attrs: {
                                                  title: _vm.$t("list.delete")
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeItems(w)
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "far fa-trash-alt"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4780bd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4780bd4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Rma/update.vue
// module id = null
// module chunks = 